import _ from 'underscore';

import connectToRouter from 'js/lib/connectToRouter';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import mapExecuteActionToProps from 'js/lib/mapExecuteActionToProps';
import mapProps from 'js/lib/mapProps';

import { savePost } from 'bundles/discussions/actions/ThreadDetailsActions';
import { clearThreadsCache } from 'bundles/discussions/actions/ThreadsActions';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import ReplyCMLInput from 'bundles/discussions/components/repliesList/ReplyCMLInput';
import { naptimeForumTypes } from 'bundles/discussions/constants';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';

export default _.compose(
  discussionsForumsHOC({ fields: ['link', 'title'] }),
  connectToRouter(routerConnectToCurrentForum),
  mapExecuteActionToProps((executeAction: $TSFixMe, props: $TSFixMe) => {
    return {
      handleSubmit: (post: $TSFixMe) => {
        executeAction(clearThreadsCache);
        executeAction(savePost, post);
      },
    };
  }),
  mapProps((props) => {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (props.currentForum && props.currentForum.forumType.typeName === naptimeForumTypes.groupForumType) {
      return {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        contextId: props.currentForum.forumType.definition.groupId,
      };
    }

    return {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      contextId: props.courseId,
    };
  })
)(ReplyCMLInput);
